module.exports = __webpack_public_path__ + "img/logo_dp.d1964bef.png";